import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as AngleDown } from '../../../../../assets/icons/angle-down.svg';
import './returns_toggler.component.css';

const ReturnsToggler = (props) => {
  const returnsTypes = [
    { name: 'XIRR', value: 'xirr' },
    { name: 'Absolute', value: 'abs' },
  ];

  const valueNameMap = {
    abs: 'Absolute',
    xirr: 'XIRR',
  };

  return (
    <>
      <Dropdown className="returns_dropdown">
        <Dropdown.Toggle>
          <span>{valueNameMap[props.returnsType]}</span>
          <span>
            <AngleDown />
          </span>
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {returnsTypes.map((type) => {
            return (
              <Dropdown.Item
                key={type.value}
                onClick={() => {
                  props.setReturnsType(type.value);
                }}
              >
                {type.name}
              </Dropdown.Item>
            );
          })}
        </Dropdown.Menu>
      </Dropdown>
      <div className="returns_toggler">
        <label className="switch">
          <input
            type="checkbox"
            onChange={(e) => {
              let value = 'abs';
              if (e.target.checked) {
                value = 'xirr';
              }
              props.setReturnsType(value);
            }}
          />
          <span className="slider round"></span>
        </label>
        <span>{props.returnsType === 'abs' ? 'Abs' : 'XIRR'}</span>
      </div>
    </>
  );
};

export default ReturnsToggler;
